import { BaseService } from './BaseService';

export interface AreaOfLawDropdownItem {
  value: string;
  label: string;
}

class AreaOfLawService extends BaseService<AreaOfLawDropdownItem> {
  constructor() {
    super('/api/AreaOfLaw');
  }

  async getDropdownAreaOfLaw(): Promise<AreaOfLawDropdownItem[]> {
    try {
      return await this.get<AreaOfLawDropdownItem[]>('/dropdown');
    } catch (error) {
      console.error('Error fetching area of law dropdown:', error);
      throw error;
    }
  }
}

export const areaOfLawService = new AreaOfLawService();
